import { useState, useEffect } from "react";

export const AnimatedCounter = ({ end, suffix = "", label, isInView }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (isInView) {
      const duration = 2000;
      const steps = 60;
      const increment = end / steps;
      let current = 0;
      
      const timer = setInterval(() => {
        current += increment;
        if (current >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(current));
        }
      }, duration / steps);

      return () => clearInterval(timer);
    }
  }, [isInView, end]);

  return (
    <div className="text-center">
      <div className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gold mb-2">
        +{count}{suffix}
      </div>
      <div className="text-white/80 text-sm sm:text-base md:text-lg font-medium">{label}</div>
    </div>
  );
};
export default AnimatedCounter;